// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2YE91","filesListContainer":"PosDisputesFiles_filesListContainer__1QBQc","filesButton":"PosDisputesFiles_filesButton__35cSk"};